module.exports = __webpack_public_path__ + "static/media/Gryllson.ecbe4f4e.png";